import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileSidebar from "../Sidebar/ProfileSidebar";
import ProfileMainSection from "../profilemainsection/ProfileMainSection";
import { Menu } from "lucide-react";

const ProfileLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbLabel = () => {
    const path = location.pathname;
    if (path.includes("booking")) return "My Bookings";
    if (path.includes("password")) return "Password Settings";
    if (path.includes("help")) return "Help & Support";
    if (path.includes("profile") || path.includes("profile-section")) return "Account Settings";
    return "Dashboard";
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-outfit relative">
      
      {/* Dark Hero Background for Navbar Visibility & Premium Look */}
      <div className="absolute top-0 left-0 w-full h-[180px] bg-[#020617] z-0 overflow-hidden rounded-b-[2rem] shadow-xl">
         <div className="absolute inset-0 opacity-20">
            <img src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80&w=2000" alt="cover" className="w-full h-full object-cover" />
         </div>
         <div className="absolute inset-0 bg-gradient-to-b from-[#020617]/50 to-[#020617]"></div>
      </div>

      {/* Container for Breadcrumbs + Layout */}
      <div className="relative z-10 pt-24 pb-20 max-w-7xl w-full mx-auto px-4 md:px-6">
        
        {/* Dynamic Breadcrumbs */}
        <div className="text-white text-xs font-bold uppercase tracking-widest mb-6 opacity-80 flex items-center gap-2">
            <span className="cursor-pointer hover:text-blue-300 transition-colors" onClick={() => navigate("/home")}>Home</span>
            <span>/</span>
            <span className="text-white opacity-100">{getBreadcrumbLabel()}</span>
        </div>

        {/* Sidebar + Content Grid */}
        <div className="flex flex-col md:flex-row gap-8 items-start w-full">
        
        {/* Sidebar - Positioned correctly for mobile and desktop */}
        <ProfileSidebar 
          isSidebarOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
        />

        {/* Backdrop for mobile */}
        {isSidebarOpen && (
          <div 
            className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 md:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        <ProfileMainSection>
          {/* Mobile Sidebar Toggle Button */}
          <div className="md:hidden mb-6 flex justify-end">
            <button 
              onClick={() => setIsSidebarOpen(true)}
              className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-slate-700 font-bold text-xs shadow-sm active:scale-95 transition-all"
            >
              <Menu size={16} /> Account Menu
            </button>
          </div>
          
          {children}
        </ProfileMainSection>
      </div>
      </div>
    </div>
  );
};

export default ProfileLayout;
